import userStore from '../../stores/UserStore'

// Antes: se calculaba una sola vez al importar el módulo, quedando
// "congelado" con el valor que tuviera el store en ese instante (casi
// siempre false, porque la API de roles aún no había respondido).
//
// Ahora: se exporta una función que lee el getter reactivo del store
// cada vez que se llama, así siempre refleja el estado actual.
export default function isSuperAdmin() {
	return userStore.getters.isSuperAdmin
}